module.exports = __webpack_public_path__ + "static/img/attribution-flou.66d4662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/attribution-flou.jpg
// module id = XOsN
// module chunks = 4